import { useQuery } from '@tanstack/react-query';

import { parkingApi } from '@api/parking.api';
import { ParkingWatch } from '@models/parking.types';
import { apartmentStore } from '@stores/apartmentStore';

import { useObservable } from './useObservable';

/** Hook that returns selected apartment's parking watches */
export const useParkingWatchForSelectedApartment = () => {
  const selectedApartment = useObservable(
    () => apartmentStore.selectedApartment
  );

  const isEnabled = !!selectedApartment;

  const {
    data: myParkingWatches,
    isLoading,
    ...rest
  } = useQuery(
    PARKING_WATCH_QUERY_KEY,
    async () => {
      const response = await parkingApi.getParkingWatches();
      return response.data;
    },
    { enabled: isEnabled }
  );

  const apartmentParkingAreaIds =
    apartmentStore.selectedApartment?.realestate?.parkingAreas?.map(
      (area) => area.id
    ) || [];

  // Filter parking watches that match the apartment's parking area IDs
  const parkingWatchesForApartment = myParkingWatches?.filter(
    (watch: ParkingWatch) =>
      watch.parkingAreaIds.some((id) => apartmentParkingAreaIds.includes(id))
  );

  return {
    parkingWatchesForApartment,
    ...rest,
    // if query is disabled `isLoading` is true by default
    isLoading: isEnabled && isLoading,
  };
};

export const PARKING_WATCH_QUERY_KEY = ['parking-watches'];
